import { WifiSlash } from '@phosphor-icons/react'
import { useNetworkStatus } from '@/api'
import { useI18n } from '@/i18n'

export function OfflineBanner() {
  const { online } = useNetworkStatus()
  const { t } = useI18n()
  if (online) return null
  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-warn/30 bg-warn-wash px-4 py-2 text-[13px] text-ink"
    >
      <WifiSlash weight="bold" className="shrink-0 text-warn" aria-hidden="true" />
      <span>{t('common.youAreOffline')}</span>
    </div>
  )
}
